import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import UserApi from "../services/userApi";
import AppApi from "../services/appApi";
import {
    GET_QUERY_CATEGORY_RESPONSE,
    GET_QUERY_CATEGORY_FAILED,
    GET_QUERY_SUB_CATEGORY_RESPONSE,
    GET_QUERY_SUB_CATEGORY_FAILED,
    RAISE_QUERY_CLIENT_PMS_RESPONSE,
    RAISE_QUERY_CLIENT_PMS_FAILED,
    RAISE_QUERY_CLIENT_MF_RESPONSE,
    RAISE_QUERY_CLIENT_MF_FAILED,
    RAISE_QUERY_FAILED,
    RAISE_QUERY_RESPONSE,
    RAISE_QUERY_CLIENT_AIF_RESPONSE,
    RAISE_QUERY_CLIENT_AIF_FAILED,
    CLIENT_AIF_FAILED, CLIENT_AIF_RESPONSE, CLIENT_MF_RESPONSE, CLIENT_MF_FAILED, GET_RAISE_QUERY_RESPONSE, GET_RAISE_QUERY_FAILED

} from '../redux/types/raiseQuery';
let api = new UserApi();
let api2 = new AppApi()

export function* getQueryCategory({ payload, resolve }) {
    let responsePayload = {};
    let responsePayloadLoader = { start: true, stop: false };
    try {
        let { data } = yield api.GetQueryCategory(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data.success) {
            let responseData = data.data;
            responsePayload = formatQueryCategory(responseData)
            yield put({ type: GET_QUERY_CATEGORY_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_QUERY_CATEGORY_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_QUERY_CATEGORY_FAILED, payload: responsePayload })

    }
}

export function* getQuerySubCategory({ payload, resolve }) {
    let responsePayload = {};
    let responsePayloadLoader = { start: true, stop: false };
    try {
        let { data } = yield api.GetQuerySubCategory(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data.success) {
            let responseData = data.data;
            responsePayload = formatQuerySubCategory(responseData)
            yield put({ type: GET_QUERY_SUB_CATEGORY_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_QUERY_SUB_CATEGORY_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_QUERY_SUB_CATEGORY_FAILED, payload: responsePayload })

    }
}

export function* RaiseQueryClientMF({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.RaiseQueryClientMF(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.details = responseData;
            let uniqueFolioList = [...new Set(responseData.schemeDetails.map(a => a.folioNo))];
            responsePayload.uniqueFolioList = uniqueFolioList;

            yield put({ type: RAISE_QUERY_CLIENT_MF_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: RAISE_QUERY_CLIENT_MF_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: RAISE_QUERY_CLIENT_MF_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* RaiseQueryClientPMS({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.RaiseQueryClientPMS(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload = responseData;
            yield put({ type: RAISE_QUERY_CLIENT_PMS_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: RAISE_QUERY_CLIENT_PMS_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: RAISE_QUERY_CLIENT_PMS_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* RaiseQueryClientAIF({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.RaiseQueryClientAIF(payload);
        console.log("data", data)
        if (data.success) {
            let responseData = data.data;
            responsePayload.details = responseData;
            let uniqueFolioList = [...new Set(responseData.schemeDetails.map(a => a.folioNo))];
            responsePayload.uniqueFolioList = uniqueFolioList;

            yield put({ type: RAISE_QUERY_CLIENT_AIF_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: RAISE_QUERY_CLIENT_AIF_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: RAISE_QUERY_CLIENT_AIF_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* RaiseQuery({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.RaiseQuery(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload = responseData;
            yield put({ type: RAISE_QUERY_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: RAISE_QUERY_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: RAISE_QUERY_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* ClientAIF({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.ClientAIF(payload);
        console.log("data", data)
        if (data.success) {
            let responseData = data.data;
            responsePayload.details = responseData;
            let uniqueFolioList = [...new Set(responseData.schemeDetails.map(a => a.folioNo))];
            responsePayload.uniqueFolioList = uniqueFolioList;

            yield put({ type: CLIENT_AIF_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: CLIENT_AIF_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: CLIENT_AIF_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* ClientMF({ payload, resolve }) {
    let responsePayload = {};
    let mfArnList = [];
    let mfFilterDistName = []
    try {
        let { data } = yield api.ClientMF(payload);
        console.log("data", data)
        if (data.success) {
            let responseData = data.data;
            let uniqueFolioList = [...new Set(responseData.map(a => a.foliono))];
            let uniquePanList = [...new Set(responseData.map(a => a.pan))];
            let uniqueMfDistcode = [...new Set(responseData.map(a => a.distributorName + "-" + "[" + a.distributorCode + "]"))];
            mfFilterDistName = uniqueMfDistcode.map((val) => {
                let filtervalue = val.split('-')[0];
                return {

                    value: filtervalue,
                    label: val

                }
            })
            console.log("mfFilterDistName", mfFilterDistName);
            responsePayload.details = responseData;
            responsePayload.uniqueFolioList = uniqueFolioList;
            responsePayload.uniquePanList = uniquePanList;
            responsePayload.mfFilterDistName = mfFilterDistName;
            yield put({ type: CLIENT_MF_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: CLIENT_MF_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: CLIENT_MF_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* GetRaiseQuery({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetRaiseQuery(payload);
        if (data.success) {
            console.log("data", data.data);
            let responseData = data.data;
            responsePayload.RaiseQueryDetails = responseData;
            yield put({ type: GET_RAISE_QUERY_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_RAISE_QUERY_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_RAISE_QUERY_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}



//utils

function formatQueryCategory(data) {
    let dropDown = data.map(({ categoryId, categoryName }) => {
        return { label: categoryName, value: categoryId }
    })
    return dropDown;
}

function formatQuerySubCategory(data) {
    let dropDown = data.map(({ subCategoryId, subCategoryName }) => {
        return { label: subCategoryName, value: subCategoryId }
    })
    return dropDown;
}